import React, { Fragment, FunctionComponent, memo } from 'react'
import styles from './UpdateElement.module.sass'
import { HistoryAction, HistoryData, HistoryResources } from '../../../../../../responses/history'
import type { FactoryIcons } from '../factory'
import { last } from 'fp-ts/es6/NonEmptyArray'
import ChevronRightIcon from 'files/chevron/right.svg'
import Ellipsis from '../../../../../etc/Ellipsis/Ellipsis'
import { SimpleRenderer, TextRenderer } from '../factory-types'

interface Props {
    data: HistoryData,
    action: HistoryAction,
    resources: HistoryResources,
    icons: FactoryIcons,
    renderer?: SimpleRenderer,
    text?: TextRenderer,
}

const UpdateElement: FunctionComponent<Props> = props => <div className={styles.element}>
    {
        typeof props.icons === 'function' ?
            props.icons(last(props.action.values)) :
            props.icons[props.action.type] ?? <div/>
    }
    {
        props.renderer ?
            (props.action.type === 'change' ?
                    <>
                        <div className={styles.firstColumn}>{props.renderer(props.resources)(props.action.values[0])}</div>
                        <ChevronRightIcon className={styles.icon}/>
                        <div className={styles.secondColumn}>{props.renderer(props.resources)(props.action.values[1])}</div>
                    </> :
                    <>
                        <Ellipsis className={styles.firstColumn}>
                            {props.text?.(last(props.action.values)) ?? props.action.text}
                        </Ellipsis>
                        {
                            props.action.values.map(id => <Fragment key={id as string}>
                                <ChevronRightIcon className={styles.arrow}/>
                                <div className={styles.secondColumn}>{props.renderer?.(props.resources)(id)}</div>
                            </Fragment>)
                        }
                    </>
            ) :
            <div>{props.action.text}</div>
    }
</div>

export default memo(UpdateElement)